import { createSelector } from 'reselect';
import { replace } from 'react-router-redux';
import { SubmissionError, reset } from 'redux-form';
import moment from 'moment';
import {actions as generalActions} from './../../general';

import { getRequestQuery, makeQueryBySettings, makeFilterSettings } from '../../shared/utils';

import endpoints from '../../../../config/endpoints';
import http from '../../../shared/http';

import find from 'lodash/find';
import forEach from 'lodash/forEach';
import orderBy from 'lodash/orderBy';

const defaultInitialState = {
	isOpen: false,
	data: null
};

const createSaveExport = ({ namespace, stateNodeName = 'savedFilters' }) => {
	// action types
	const SAVE_TOGGLE = `${namespace}/${stateNodeName}-control-toggle`;
	const APPLY_SAVED_FILTER_CURRENCY = `${namespace}/${stateNodeName}-apply-saved-filter-currency`;
	const SAVE_POST_FILTERS_SUCCESS = `${namespace}/${stateNodeName}-post-filters-success`;
	const SAVE_POST_FILTERS_ERROR = `${namespace}/${stateNodeName}-post-filters-error`;
	const SHOW_PROGRESS_BAR = `${namespace}/show-progress-bar`;

	// init state
	const initialState = {
		...defaultInitialState
	};

	const actions = {
		[`${stateNodeName}Toggle`]: () => ({
			type: SAVE_TOGGLE
		}),

		[`${stateNodeName}Apply`]: id => (dispatch, getState) => {
			const filter = find(getState()[`${namespace}`].savedFilters.data, { id });
			const settings = filter.settings || {};

			settings.date_range = {
				start: moment().subtract(6, 'days').format('YYYY-MM-DD'),
				end: moment().add(1, 'days').format('YYYY-MM-DD')
			};
			dispatch(generalActions.statsResetFromSavedFilter());
			const query = makeQueryBySettings(settings);
			const location = namespace === 'statistics' ? 'general' : 'conversions';
			dispatch(actions[`${stateNodeName}Toggle`]());
			dispatch(replace(`statistics/${location}?${query}`));
			dispatch({
				type: APPLY_SAVED_FILTER_CURRENCY,
				payload: settings.currency
			});
		},

		[`${stateNodeName}Save`]: formData => (dispatch, getState) => {
			const appState = getState();
			const activeBalance = appState.app && appState.app.userData && appState.app.userData.activeBalance;
			const selectedFilters = makeFilterSettings(
				getRequestQuery(appState[`${namespace}`], activeBalance),
				appState[`${namespace}`]
			);
			const title = (formData && formData.title) || '';

			const request = http({
				url: `${endpoints.PROFILE.SAVED_FILTERS}`,
				method: 'post',
				actions: [SAVE_POST_FILTERS_SUCCESS, SAVE_POST_FILTERS_ERROR],
				addToResponse: {
					title,
					settings: selectedFilters
				},
				data: {
					title,
					settings: selectedFilters
				}
			});

			dispatch(actions.showProgressBar());
			dispatch(reset('saveFiltersForm'));

			return request(dispatch).then(action => {
				const { type, payload } = action;

				if (type === SAVE_POST_FILTERS_ERROR && payload.response.status === 400) {
					const validationErrors = {};
					const responseErrors = payload.response.data;

					forEach(responseErrors, value => {
						let key = value.dataPath.slice(1);
						validationErrors[key] = value.message;
					});

					throw new SubmissionError(validationErrors);
				}
			});
		},
		showProgressBar: () => ({
			type: SHOW_PROGRESS_BAR
		})
	};

	const reducers = {
		[SAVE_TOGGLE]: state => {
			return {
				...state,
				savedFilters: {
					...state.savedFilters,
					isOpen: !state.savedFilters.isOpen
				}
			};
		},
		[APPLY_SAVED_FILTER_CURRENCY]: (state, action)=> ({
			...state, query: {...state.query,
				currency: action.payload
			}
		}),
		[SAVE_POST_FILTERS_SUCCESS]: (state, action) => {
			const { id, title, settings } = action.payload.data && action.payload.data[0];

			return {
				...state,
				showProgressBar: false,
				savedFilters: {
					isOpen: false,
					data: state.savedFilters && state.savedFilters.data
						? state.savedFilters.data.concat([{ id, title, settings }])
						: [{ id, title, settings }]
				}
			};
		},
		[SAVE_POST_FILTERS_ERROR]: (state, action) => ({
			...state,
			showProgressBar: false
		})
	};

	const selectors = {
		getSavedFilters: (savedFiltersSelector, appState) =>
			createSelector(savedFiltersSelector, appState, (savedFilters, appState) => {
				return {
					...appState[`${namespace}`].savedFilters,
					data: orderBy(appState[`${namespace}`].savedFilters.data, item => +item.id, ['desc'])
				};
			})
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createSaveExport;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/save-export/index.js